import React from "react";
import SettingsItemDesktop from "./SettingsItemDesktop";
import General from "../common/Sections/General";
import SettingsSectionHeader from "../common/SettingsSectionHeader";

const SettingsDesktop = ({ sections, user, routeSection, roles, tabs, isRiskLocked }) => {
  return (
    <>
      <General className="mb-2" user={user} isRiskLocked={isRiskLocked} />
      {tabs.map((tab, idx) => {
        return (
          <div className="border rounded shadow-md p-4 mt-4">
            <SettingsSectionHeader header={tab}/>
            {Object.values(sections[idx]).map(
              ({ title, summary, Component, accessor, canExpand = () => true }) => (
                <SettingsItemDesktop
                  key={title}
                  title={title}
                  summary={summary}
                  Component={Component}
                  accessor={accessor}
                  user={user}
                  roles={roles}
                  isRiskLocked={isRiskLocked}
                  initiallyExpanded={
                    routeSection === title.toLowerCase().replace(/ /g, "-")
                  }
                  canExpand={canExpand({ isRiskLocked })}
                />
              ),
            )}
          </div>
        );
      })}
    </>
  );
};

export default SettingsDesktop;
